import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/List/List.module.scss';
import React from 'react';
import classNames from 'classnames';
import Content from 'wienenergiedesignsystem/components/Content/Content';

var List = function List(_ref) {
  var _classNames;

  var type = _ref.type,
      noSpacing = _ref.noSpacing,
      children = _ref.children,
      Icon = _ref.icon,
      align = _ref.align,
      variant = _ref.variant,
      className = _ref.className;
  var Element = {
    as: type === 'checkmark' ? 'ul' : type
  };

  var renderCheckMark = function renderCheckMark() {
    if (!Icon) {
      return "The prop 'icon' must be passed when used with the type 'checkmark'";
    }

    return /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.circle, styles[variant])
    }, /*#__PURE__*/React.cloneElement(Icon, {
      className: styles.icon
    }));
  };

  var renderBullet = function renderBullet() {
    if (!Icon) {
      return "The prop 'icon' must be passed when used with the type 'ul'";
    }

    return /*#__PURE__*/React.cloneElement(Icon, {
      className: styles.icon
    });
  };

  var getIcon = function getIcon() {
    switch (type) {
      case 'checkmark':
        return renderCheckMark();

      case 'ul':
        return renderBullet();

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(Element.as, {
    className: classNames(styles.list, (_classNames = {}, _classNames[styles.noSpacing] = noSpacing, _classNames), className)
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      type: type,
      icon: getIcon(),
      align: align,
      variant: variant
    });
  }));
};

List.defaultProps = {
  variant: 'success',
  type: 'ul',
  noSpacing: false,
  icon: null,
  align: 'leading'
};

var ListItem = function ListItem(_ref2) {
  var type = _ref2.type,
      children = _ref2.children,
      icon = _ref2.icon,
      align = _ref2.align,
      className = _ref2.className,
      variant = _ref2.variant,
      props = _objectWithoutPropertiesLoose(_ref2, ["type", "children", "icon", "align", "className", "variant"]);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React.createElement("li", Object.assign({
    className: classNames(styles[type], styles[align], styles[variant], className)
  }, props), icon, /*#__PURE__*/React.createElement(Content, {
    withParser: true,
    as: "span",
    className: styles.text
  }, children));
};

ListItem.defaultProps = {
  variant: 'success',
  type: 'ul',
  align: 'leading'
};
export { List as default, ListItem };